<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Date"><br>
                                <a-range-picker v-model="inputDate" format="MM-DD-YYYY" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Document Type">
                                <select class="form-control" v-model="inputDocumentType">
                                    <option v-for="option in documentTypeOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{option.value}}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>  

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Serial Number">
                                <a-input placeholder="All Serial Number" v-model="inputSerial" />
                            </base-input>
                        </div>
                    </div>  

                    <div class="row">
                        <div class="col-md-4">
                            <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                {{toggleLabel}}
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'

    import {
        mapState
    } from 'vuex'
import reportUtils from '../../components/reportUtils.js';
    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputDocumentType: "",
                documentTypeOptions: [],
                inputSerial: "",
                birSalesReports:[],
                JsonData: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            var document_types = await HTTPRequest.getRequest(this.endPoint + 'document_types/get_valid_document_types', null)
            this.documentTypeOptions = document_types


        },
        computed: {
            ...mapState(['currentProfile', 'endPoint']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            generateReport: async function () {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'No records returned. Please make sure to check your filters.');
                    return
                }
                
                let from_header = this.inputDate[0].format('MMMM DD, YYYY hh:mm A')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY hh:mm A')

                let parameters = {
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm'), 
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm'),
                    "site_id": this.inputSite,
                    "document_type_id": this.inputDocumentType,
                    "serial_number": this.inputSerial,
                    "advanced_filter": this.params
                    }

                var serials = await HTTPRequest.getRequest(this.endPoint + 'serial_tracking_reports', parameters)

                if(serials.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];

                    let header_detail = [];

                    header_detail.push(
                        {content: 'Site Name', styles: {halign: 'center'}},
                        {content: 'Document', styles: {halign: 'center'}},
                        {content: 'Document ID', styles: {halign: 'center'}},
                        {content: 'Document Date', styles: {halign: 'center'}},
                        {content: 'Party', styles: {halign: 'center'}},
                        {content: 'Barcode', styles: {halign: 'center'}},
                        {content: 'Product Name', styles: {halign: 'center'}},
                        {content: 'Serial Number', styles: {halign: 'center'}}
                    )

                    headers = [header_detail]
                    let reportData = []

                    for(let i=0; i < serials.length; i++){
                        let reportLine = serials[i]
                        
                        let detail = []
                        detail.push(
                            reportLine.SITE_NAME,
                            reportLine.DOCUMENT_NAME,
                            reportLine.DOCUMENT_ID,
                            reportLine.DOCUMENT_DATE,
                            reportLine.DOCUMENT_PARTY,
                            reportLine.BARCODE,
                            reportLine.PRODUCT_NAME,
                            reportLine.SERIAL_NUMBER
                        )
                        reportData.push(Object.assign({}, detail))

                    }

                    doc.setFontSize(14);
                    doc.setFontType("bold");
                    doc.text(15,20,"Serial Tracking Report")
                    doc.setFontType("normal");
                    doc.setFontSize(10);
                    

                    let site_text = ''
                    if(this.inputSite.length == 0){
                        site_text = 'All Sites'
                    } else {
                        let sites = this.inputSite
                        for (var s = 0; s < sites.length; s++) {
                            if(s == 0){
                                site_text += this.siteOptions.find(x => x.id === sites[s]).name
                            } else {
                                site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                            }
                        }
                    }
                    doc.text(340,20,site_text,"right");
                    doc.text(15,25,"From " + from_header + " to " + to_header)

                    let colStyles = {
                        0: {cellWidth: 40},
                        1: {cellWidth: 40},
                        2: {cellWidth: 25},
                        3: {cellWidth: 25},
                        4: {cellWidth: 40},
                        5: {cellWidth: 40},
                        6: {cellWidth: 70},
                        7: {cellWidth: 40},
                    }

                    doc.autoTable({
                        startY: 35, 
                        head: headers, 
                        body: reportData, 
                        theme: 'plain',
                        tableWidth: 'wrap',
                        headStyles: {
                            lineWidth: 0.15,
                            cellPadding: 2
                        },
                        styles: {
                            cellPadding: 1.0, fontSize: 10
                        },
                        columnStyles: colStyles,

                    });


                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }
                    
                    doc.text(15,200,"Printed By: " + printed_by)
                    doc.text(340,200,"Serial Tracking Report", "right")

                    doc.text(15,205,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA"))
                    //doc.text(340,205,"Page " + ( x + 1)  + " of " + serials.length, "right")
                    
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Stock_Valuation_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'No records returned. Please make sure to check your filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                 if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'No records returned. Please make sure to check your filters.');
                    return
                }
                
                let from_header = this.inputDate[0].format('MMMM DD, YYYY hh:mm A')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY hh:mm A')

                let parameters = {
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm'), 
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm'),
                    "site_id": this.inputSite,
                    "document_type_id": this.inputDocumentType,
                    "serial_number": this.inputSerial,
                    "advanced_filter": this.params
                    }

                var serials = await HTTPRequest.getRequest(this.endPoint + 'serial_tracking_reports', parameters)
                if(serials.length > 0){
                    let headers = [];
                    let site_specific = [];
                    let header_detail = [];

                    header_detail.push('Site Name','Document', 'Document ID','Document Date','Party','Barcode','Product Name','Serial Number',)
                    headers = header_detail
                    let reportData = []
                    for(let i=0; i < serials.length; i++){
                        let reportLine = serials[i]
                        
                        let detail = []
                        detail.push(
                            reportLine.SITE_NAME,
                            reportLine.DOCUMENT_NAME,
                            reportLine.DOCUMENT_ID,
                            reportLine.DOCUMENT_DATE,
                            reportLine.DOCUMENT_PARTY,
                            reportLine.BARCODE,
                            reportLine.PRODUCT_NAME,
                            reportLine.SERIAL_NUMBER
                        )
                        reportData.push(Object.assign({}, detail))

                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    reportData.push(["Serial Tracking Report", "Generate By: " + printed_by,"From " + from_header + " to " + to_header])

                    let keys = headers;
                    let values = reportData;
                    var values_length = values.length;

                    let newJsonData=[];

                    // change headers and report data as key and value object
                    for(var i=0;i < values_length; i++){
                        var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                                }
                            )
                        )
                        );
                        newJsonData.push(result)
                    }

                    // change undefined on arr
                    newJsonData.forEach(function(obj) {
                        for(var i in obj) {
                        if(obj[i] === undefined || obj[i] === null ) {
                            obj[i] = '';
                        }
                        }
                    });
                    site_specific.push(newJsonData)

                        // this.JsonData = site_specific;
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'No records returned. Please make sure to check your filters.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>